import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 30000,
})

Vue.prototype.$http = axiosIns

export default axiosIns
